<div class="chart-wrapper"><canvas (dblclick)="onDblClick($event)"></canvas></div>
<div *ngIf="!boxPlotData.datasets.length" class="no-data-text">
  <div>No data available</div>
</div>
